<template>
    <v-card elevation="5" class="w-[450px] !p-3 !flex !items-center !justify-center !animate-pulse !rounded-3xl !bg-[#00000085] !backdrop-blur-md !border-0" dark>
        <div class="items-center justify-center font-Nunito text-xl text-center">
            <Icon class="text-8xl !m-auto mb-4" :color="colorAsRoute" icon="mdi:checkbox-marked-circle-auto-outline" />
            <div>
                Congratulations, you've seen all available <strong>users</strong>. Want to see more? Invite your friends to join
                our
                platform. Thank you for being a part of Magnum-xl community!
            </div>
        </div>
    </v-card>
</template>
<script>
import { Icon } from '@iconify/vue2';

export default {
    components: { Icon },
    computed: {
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },
    },


}

</script>

<style></style>